import AppRouter from './router/AppRouter'

import './App.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import { LanguageProvider } from './context/LangaugeContextProvider/LangaugeContextProvider'

function App() {
  return (
    <div className="w-full h-full">
      <LanguageProvider>
        <AppRouter />
      </LanguageProvider>
    </div>
  )
}

export default App
